import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
    const { admin, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center text-white/60">
                <Loader2 className="animate-spin" size={22} />
                <span className="ml-3 uppercase tracking-[0.2em] text-xs">Checking session</span>
            </div>
        );
    }
    if (!admin) return <Navigate to="/admin/login" replace />;
    return children;
}
